// import {ElementType} from "react";
// import Link from "next/link";
import {IconType} from "@onemind-services-llc/react-icons-ng";
import {StaticImageData} from "next/image";
import EDR from "public/cyber-security/icons/EDR.png";
import ransomware from "public/cyber-security/icons/ransomware.png";
import ZTNA from "public/cyber-security/icons/ZTNA.png";
import vulnerability from "public/cyber-security/icons/vulnerability.png";
import complianceManagement from "public/cyber-security/icons/compliance-management.png";
import SASE from "public/cyber-security/icons/SASE.png";
import baremetalImg from "public/iaas/baremetal.png";
import blockStorageImg from "public/iaas/block_storage1.png";
import dedicatedServerImg from "public/iaas/dedicated_server.png";
import disasterRecoveryImg from "public/iaas/disaster_recovery.png";
import gpuHostingImg from "public/iaas/gpu_hosting.png";
import kubernetesImg from "public/iaas/kubernetes.png";
import vdiImg from "public/iaas/virtual_device_infrastructure.png";
// import ManagedUnmanagedComanaged from "public/privateCloud/icons/managed-unmanaged-comanaged.png";
import OpenStackCloud from "public/privateCloud/icons/openstack-cloud.png";
import VMwareCloud from "public/privateCloud/icons/vmware-cloud.png";
import ZadaraCloud from "public/privateCloud/icons/zadara-cloud.png";
import CertificationLabs from "public/pocCloud/icons/certification-labs.png";
import EmulateSimulateReal from "public/pocCloud/icons/emulate-simulate-real.png";
import NetworkAutomation from "public/pocCloud/icons/network-automation.png";
import NetworkDigitalTwins from "public/pocCloud/icons/network-digital-twins.png";
import PerformanceLabs from "public/pocCloud/icons/performance-labs.png";
import PhysicalLabs from "public/pocCloud/icons/physical-labs.png";
import CloudUnifiedCom from "public/network-services/icons/cloud-unified-com.png";
import InternetDCI from "public/network-services/icons/internet-dci.png";
import NetworkNMS from "public/network-services/icons/network-nms.png";
import NocSocHelpdesk from "public/network-services/icons/noc-soc-helpdesk.png";
import SdnSdWan from "public/network-services/icons/sdn-sd-wan.png";
import WiredWirelessNetwork from "public/network-services/icons/wired-wireless-network.png";
import HostedElastic from "public/application-services/icons/hosted-elastic.png";
import HostedGrafana from "public/application-services/icons/hosted-grafana.png";
import HostedNetbox from "public/application-services/icons/hosted-netbox.png";
import HostedOpenText from "public/application-services/icons/hosted-open-text.png";
import HostedPBX from "public/application-services/icons/hosted-pbx.png";
import Inuvika from "public/application-services/icons/inuvika.png";
import Rancher from "public/application-services/icons/rancher.png";
import AppleMac from "public/application-services/icons/ic_baseline-apple.png";

import {
  CLOUD_SERVICES_ROUTES,
  SECURITY_SERVICES_ROUTES,
  MAIN_ROUTES,
  NETWORK_SERVICES_ROUTES,
  APPS_ROUTES,
  CLOUD_MIGRATIONS_ROUTES,
} from "@/constants/routes";

export type NavItem = {
  icon?: IconType;
  image?: StaticImageData;
  label: string;
  subLabel?: string;
  href?: string;
  children?: NavItem[];
};

// export const USER_LINKS: {name: string; as: ElementType | string; path: string}[] = [
//   {name: "Services", as: Link, path: MAIN_ROUTES.SERVICES},
//   {name: "Logout", as: "a", path: MAIN_ROUTES.LOGOUT},
// ];

export const PRIVATE_CLOUD_CONSTANTS = [
  {
    image: ZadaraCloud,
    label: "Zadara Cloud",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ZADARA_CLOUD}`,
  },
  {
    image: VMwareCloud,
    label: "VMware Cloud",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VMWARE_CLOUD}`,
    children: [
      {
        image: disasterRecoveryImg,
        label: "Disaster Recovery ",
        href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.DISASTER_RECOVERY}`,
      },
    ],
  },
  // {
  //   image: disasterRecoveryImg,
  //   label: "OEM Converged Architecture",
  //   href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OEM_CONVERGED_ARCHITECTURE}`,
  // },
  {
    image: kubernetesImg,
    label: "Private Kubernetes clusters",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PRIVATE_K8_CLUSTERS}`,
  },
  {
    image: dedicatedServerImg,
    label: "Managed Open Stack (MOST)",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OPEN_STACK_CLOUD}`,
  },
  {
    image: gpuHostingImg,
    label: "Virtuozzo PaaS",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VIRTUOZZO_PAAS}`,
  },
  {
    image: dedicatedServerImg,
    label: "Encrypted Storage Clusters",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.ENCRYPTED_STORAGE_CLUSTERS}`,
  },
  {
    image: NetworkNMS,
    label: "VDI on Private Cloud",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PRIVATE_VDI}`,
  },
  // {
  //   image: ManagedUnmanagedComanaged,
  //   label: "Managed, Unmanaged, Co-managed",
  //   href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MANAGED_UNMANAGED_CO_MANAGED}`,
  // },
];

export const COMPUTE_CONSTANTS = [
  {
    image: dedicatedServerImg,
    label: "Dedicated Compute (Intel | AMD)",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.DEDICATED_SERVER}`,
  },
  {
    image: PhysicalLabs,
    label: "Shared Compute (Legacy Intel)",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.SHARED_COMPUTE}`,
  },
];

export const PUBLIC_CLOUD_CONSTANTS = [
  {
    image: blockStorageImg,
    label: "Compute",
    children: COMPUTE_CONSTANTS,
  },
  {
    image: baremetalImg,
    label: "Bare-Metal Server",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.BAREMETAL}`,
  },
  {
    image: gpuHostingImg,
    label: "Cloud GPU ",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.CLOUD_GPU}`,
  },
  {
    image: blockStorageImg,
    label: "Block Storage | S3 Storage ",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.BLOCK_AND_S3_STORAGE}`,
  },
  {
    image: NetworkNMS,
    label: "Load Balancers",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.LOAD_BALANCERS}`,
  },
  {
    image: NetworkNMS,
    label: "Public IPv4 / IPv6 ",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.IPV4V6}`,
  },
  {
    image: kubernetesImg,
    label: "Kubernetes",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.KUBERNETES}`,
  },
  // {
  //   image: gpuHostingImg,
  //   label: "Platform as a Service (PaaS)",
  //   href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PAAS}`,
  // },
  {
    image: vdiImg,
    label: "Virtual Desktop Infrastructure (VDI) ",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VDI}`,
  },
  {
    image: NetworkNMS,
    label: "Managed Microsoft 365",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.MICROSOFT_365}`,
  },
];

export const POC_CLOUD_CONSTANTS = [
  {
    image: disasterRecoveryImg,
    label: "POC-as a-Service",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.POC_AS_A_SERVICE}`,
  },
  {
    image: vdiImg,
    label: "Lab-as-a-Service",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.LAB_AS_A_SERVICE}`,
  },
  {
    image: NetworkDigitalTwins,
    label: "Network Digital Twins",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_DIGITAL_TWINS}`,
  },
  {
    image: CertificationLabs,
    label: "Certification Labs",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.CERTIFICATION_LABS}`,
  },
  {
    image: PhysicalLabs,
    label: "Physical Labs (SI | VAR|COE)",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PHYSICAL_LABS}`,
  },
  {
    image: NetworkAutomation,
    label: "Network Automation",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.NETWORK_AUTOMATION}`,
  },
  {
    image: PerformanceLabs,
    label: "Performance Labs | OEM Test Labs",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.PERFORMANCE_LABS}`,
  },
  {
    image: EmulateSimulateReal,
    label: "Emulate | Simulate | Real",
    href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.EMULATE_SIMULATE_REAL}`,
  },
];

export const SECURITY_SERVICES_CONSTANTS = [
  {
    href: `${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.EDR_MDR_XDR}`,
    image: EDR,
    label: "EDR | MDR | XDR (24/7)",
  },
  {
    href: `${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.RANSOMWARE_DDOS_PROTECTION}`,
    image: ransomware,
    label: "Ransomware & DDoS Protection",
  },
  {
    href: `${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.ZTNA_VPN_EDGE_FIREWALL_SASE}`,
    image: ZTNA,
    label: "ZTNA | VPN | Edge Firewall | SASE",
  },
  {
    href: `${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.VULNERABILITY_PATCH_MANAGEMENT}`,
    image: vulnerability,
    label: "Vulnerability and Patch Management",
  },
  {
    href: `${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.COMPLIANCE_MANAGEMENT}`,
    image: complianceManagement,
    label: "Compliance Management | SEC OPS",
  },
  {
    href: `${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.CLOUD_SECURITY}`,
    image: SASE,
    label: "Cloud security Posture Management",
  },
  {
    href: `${MAIN_ROUTES.SECURITY_SERVICES}${SECURITY_SERVICES_ROUTES.SECURITY_TESTING}`,
    image: EDR,
    label: "External Security Assessments / Pen Testing ",
  },
];

export const SD_WAN_CONSTANTS = [
  {
    label: "Cisco SD-WAN",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN}?vendor=cisco`,
  },
  {
    label: "Versa SD-WAN",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN}?vendor=versa`,
  },
  {
    label: "ARUBA SD-WAN",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN}?vendor=aruba`,
  },
  {
    label: "Fortinet SD-WAN",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN}?vendor=fortinet`,
  },
  {
    label: "Palo Alto SD-WAN",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN}?vendor=paloAlto`,
  },
];

export const CLOUD_MIGRATION_CONSTANTS = [
  {
    image: dedicatedServerImg,
    label: "VMware to Onemind MOST",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_MIGRATION}${CLOUD_MIGRATIONS_ROUTES.VMWARE_MIGRATION}`,
  },
  {
    image: ZadaraCloud,
    label: "VMware to Zadara",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_MIGRATION}${CLOUD_MIGRATIONS_ROUTES.MIGRATE_TO_ZADARA}`,
  },
  {
    image: baremetalImg,
    label: " AWS | AZURE | GCP to Onemind MOST",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_MIGRATION}${CLOUD_MIGRATIONS_ROUTES.GCP_TO_MOST}`,
  },
  {
    image: vdiImg,
    label: "AWS EC2 to Zadara",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_MIGRATION}${CLOUD_MIGRATIONS_ROUTES.EC2_TO_ZADARA}`,
  },
  {
    image: kubernetesImg,
    label: "Any K8 to Onemind Paas ",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_MIGRATION}${CLOUD_MIGRATIONS_ROUTES.K8_MIGRATE}`,
  },
];

export const NETWORK_SERVICES_CONSTANTS = [
  {
    image: OpenStackCloud,
    label: "Cloud Migration",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_MIGRATION}${CLOUD_MIGRATIONS_ROUTES.VMWARE_MIGRATION}`,
    children: CLOUD_MIGRATION_CONSTANTS,
  },
  // {
  //   image: InternetDCI,
  //   label: "Internet and DCI",
  //   href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.INTERNET_AND_DCI}`,
  // },
  {
    image: SdnSdWan,
    label: "SDN | SD-WAN ",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.SDN_SD_WAN}`,
    children: SD_WAN_CONSTANTS,
  },
  {
    image: CloudUnifiedCom,
    label: "Unified Communication",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_UNIFIED_COMMUNICATION}`,
    children: [
      {
        image: InternetDCI,
        label: "Onemind's Unified Coms App ",
        href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.CLOUD_UNIFIED_COMMUNICATION}?app=apps-comp`,
      },
    ],
  },
  {
    image: WiredWirelessNetwork,
    label: "Wired and Wireless Infra",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.WIRED_AND_WIRELESS_NETWORKS}`,
  },
  {
    image: vdiImg,
    label: "Network Design and Deployment",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.DESIGN_AND_DEPLOYMENT}`,
  },
  {
    image: NetworkNMS,
    label: "NMS | Observability | Custom Netbox",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.NETWORK_OBSERVABILITY_AND_NMS}`,
  },
  {
    image: disasterRecoveryImg,
    label: "Managed Colocation ",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.COLOCATION}`,
  },
  {
    image: NocSocHelpdesk,
    label: "NOC | SOC | Helpdesk",
    href: `${MAIN_ROUTES.NETWORK_SERVICES}${NETWORK_SERVICES_ROUTES.NOC_SOC_HELPDESK}`,
  },
];

export const AppsConstants = [
  {
    label: "Managed Monitoring & Observability",
    image: EDR,
    children: [
      {
        label: "Hosted Elastic Stack Licensed",
        image: HostedElastic,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_ELASTIC}`,
      },
      {
        label: "Hosted Grafana",
        image: HostedGrafana,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_GRAFANA}`,
      },
      {
        label: " Hosted OpenText NOM",
        image: HostedOpenText,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_NOM}`,
      },
    ],
  },
  {
    label: "Managed Communication & IT Services",
    image: vdiImg,
    children: [
      {
        label: "Hosted Yeastar PBX ",
        image: HostedPBX,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_PBX}`,
      },
    ],
  },
  {
    label: "Managed Infrastructure Apps",
    image: OpenStackCloud,
    children: [
      {
        label: "Hosted NetBox (IPAM/DCIM)",
        image: HostedNetbox,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_NETBOX}`,
      },
      {
        label: "Hosted Rancher (K8s Management)",
        image: Rancher,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_RANCHER}`,
      },
    ],
  },
  {
    label: "Managed Virtual Desktops (VDI)",
    image: NocSocHelpdesk,
    children: [
      {
        label: "Inuvika VDI Platform (Linux/Windows)",
        image: Inuvika,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.INUVIKA_VDI}`,
      },
      {
        label: "Hosted Mac ( Splashtop Access)  ",
        image: AppleMac,
        href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.HOSTED_MAC}`,
      },
      // {
      //   label: "ISV Cloud Desktops (AutoCAD, Ansys, Adobe)",
      //   image: NocSocHelpdesk,
      //   href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.ISV_DESKTOPS}`,
      // },
      // {
      //   label: "GPU-Powered Workstations (NVIDIA)",
      //   image: dedicatedServerImg,
      //   href: `${MAIN_ROUTES.APPLICATION_SERVICES}${APPS_ROUTES.GPU_WORKSTATIONS}`,
      // },
    ],
  },
];

export const NAV_ITEMS: Array<NavItem> = [
  {
    label: "Cloud Services",
    href: MAIN_ROUTES.CLOUD_SERVICES,
    children: [
      {
        label: "Public Cloud",
        href: `${MAIN_ROUTES.CLOUD_SERVICES}?tab=0`,
        children: PUBLIC_CLOUD_CONSTANTS,
      },
      {
        label: "Private Cloud",
        href: `${MAIN_ROUTES.CLOUD_SERVICES}?tab=1`,
        children: PRIVATE_CLOUD_CONSTANTS,
      },
      {
        label: "POC Cloud",
        href: `${MAIN_ROUTES.CLOUD_SERVICES}?tab=2`,
        children: POC_CLOUD_CONSTANTS,
      },
      {
        label: "Application Services",
        href: MAIN_ROUTES.APPLICATION_SERVICES,
        children: AppsConstants,
      },
      // {
      //   image: baremetalImg,
      //   label: "Bare-Metal Server",
      //   href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.BAREMETAL}`,
      // },
      // {
      //   image: vdiImg,
      //   label: "Virtual Desktop Infrastructure (VDI) ",
      //   href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.VDI}`,
      // },

      // {
      //   label: "IaaS",
      //   href: MAIN_ROUTES.IAAS,
      //   children: IAAS_CONSTANTS,
      // },
      // {
      //   image: dedicatedServerImg,
      //   label: "Managed Open Stack (MOST)",
      //   href: `${MAIN_ROUTES.CLOUD_SERVICES}${CLOUD_SERVICES_ROUTES.OPEN_STACK_CLOUD}`,
      // },
    ],
  },
  {
    label: "Security Services",
    href: MAIN_ROUTES.SECURITY_SERVICES,
    children: SECURITY_SERVICES_CONSTANTS,
  },
  {
    label: "Network Services",
    href: MAIN_ROUTES.NETWORK_SERVICES,
    children: NETWORK_SERVICES_CONSTANTS,
  },
  // {
  //   label: "Application Services",
  //   href: MAIN_ROUTES.APPLICATION_SERVICES,
  //   children: APPLICATION_SERVICES_CONSTANTS,
  // },

  {
    label: "Pricing",
    href: MAIN_ROUTES.PRICING,
  },
  {
    label: "Company",
    href: MAIN_ROUTES.ABOUT_US,
    children: [
      {
        label: "About Us",
        href: MAIN_ROUTES.ABOUT_US,
      },
      {
        label: "Data Centers",
        href: MAIN_ROUTES.DATA_CENTER,
      },
      {
        label: "Our Policies",
        href: MAIN_ROUTES.POLICIES,
      },
    ],
  },
];

export const NAV_BUTTON = {
  label: "Book A Consultation",
  href: MAIN_ROUTES.BOOK_A_CONSULTATION,
};
